<ng-container *ngIf="{ isAuthInProgress: isAuthInProgress$ | async } as context">
  <ng-container *ngIf="!context.isAuthInProgress; else loadingAuth">
    <button (click)="logout()">logout</button>
  </ng-container>
  <ng-template #loadingAuth>
    <span> (Simple version ) Loading Auth </span>
  </ng-template>
</ng-container>
